import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  Dimensions,
  FlatList,
  Image,
  SafeAreaView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  ScrollView,
  Modal,
  TouchableWithoutFeedback,
  Pressable,
} from "react-native";
import AppColors from "../../Constants/AppColors";
import AppImages from "../../Constants/AppImages";
import AppFonts from "../../Constants/AppFonts";
import Appstyles from "../../Constants/AppStyles";
import useAppNavigation from "../../Routes/useAppNavigation";
// import { useTranslation } from "react-i18next";

const { width, height } = Dimensions.get("window");
const Merchant = () => {
  const navigation = useAppNavigation();
  // const { t } = useTranslation(["common"]);
  const t = (key, options = {}) => {
    // If key is an object with translation path (like "common:translation.Search Vehicle....")
    if (typeof key === "object" && key["common:translation"]) {
      return key["common:translation"];
    }

    // If key is a string, extract the text after the last colon
    if (typeof key === "string") {
      const parts = key.split(":");
      return parts[parts.length - 1].replace(/^translation./, "");
    }

    return key;
  };
  const [DotModal, setDotModal] = useState(false);
  const [Modalvisible1, setModalvisible1] = useState(false);

  // Auto-open the "Delete" confirmation modal on its PDF route.
  const location = useLocation();
  useEffect(() => {
    if (
      location.pathname === "/DispatchManagement/Merchant/MerchantRemove/Delete"
    ) {
      setModalvisible1(true);
    }
  }, [location.pathname]);

  const [activeIndex, setActiveIndex] = useState(1);
  const handleTextPress = (index) => {
    setActiveIndex(index);
  };
  const handleDeleteConfirmation = () => {
    setDotModal(false);
    setModalvisible1(true);
  };

  const screenWidth = Dimensions.get("window").width;
  const merchantData = [
    {
      name: "Merchant Name 1",
      profilePic: AppImages.Boypicture,
      merchantID: "8642",
      merchantEmail: "merchant01@gmail.com",
    },
    {
      name: "Merchant Name 2",
      profilePic: AppImages.Boypicture,
      merchantID: "8638",
      merchantEmail: "merchant02@gmail.com",
    },
    {
      name: "Merchant Name 3",
      profilePic: AppImages.Boypicture,
      merchantID: "8586",
      merchantEmail: "merchant03@gmail.com",
    },
    {
      name: "Merchant Name 4",
      profilePic: AppImages.Boypicture,
      merchantID: "8452",
      merchantEmail: "merchant04@gmail.com",
    },
    {
      name: "Merchant Name 5",
      profilePic: AppImages.Boypicture,
      merchantID: "8165",
      merchantEmail: "merchant05@gmail.com",
    },
    {
      name: "Merchant Name 6",
      profilePic: AppImages.Boypicture,
      merchantID: "8558",
      merchantEmail: "merchant06@gmail.com",
    },
  ];

  return (
    <SafeAreaView style={styles.MainView}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: "white",
          height: 58,
          justifyContent: "space-between",
          paddingHorizontal: 20,
          shadowColor: "#9C4900",
          shadowOffset: { width: 10, height: 10 },
          shadowOpacity: 10,
          shadowRadius: 10,
          elevation: 10,
        }}
      >
        <View style={Appstyles.fullAlignment}>
          <TouchableOpacity onPress={() => navigation.goBack()}>
            <Image
              source={AppImages.Backbtn}
              style={{ width: 8, height: 15, resizeMode: "contain" }}
            />
          </TouchableOpacity>
          <Text
            style={{
              color: AppColors.brown1,
              fontSize: 16,
              fontFamily: AppFonts.OverpassMedium,
              marginLeft: 20,
            }}
          >
            Merchant
          </Text>
        </View>

        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <TouchableOpacity onPress={() => navigation.navigate("#")}>
            <Image
              source={AppImages.VechicleNoti}
              style={{ width: 20, height: 20 }}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => navigation.navigate("#")}>
            <Image
              source={AppImages.Plus}
              style={{
                width: 18,
                height: 18,
                marginLeft: 15,
              }}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <View
        style={{
          backgroundColor: AppColors.white,
          // marginHorizontal: 20,
          //paddingHorizontal: 20,
          // paddingVertical: 14,
          borderRadius: 10,
          marginVertical: 20,
          borderColor: "#9C49001A",
          borderWidth: 1,
        }}
      >
        <View
          style={{
            padding: 20,
          }}
        >
          <View>
            <View style={{ width: "50%" }}>
              <TextInput
                placeholder="Merchant Name"
                placeholderTextColor={AppColors.dualbrown}
                style={{
                  paddingHorizontal: 10,
                  paddingVertical: 5,
                  borderRadius: 15,
                  borderWidth: 1,
                  borderColor: AppColors.sandal,
                  marginBottom: 10,
                  color: AppColors.brown1,
                  fontSize: 14,
                  fontFamily: AppFonts.OverpassBold,
                }}
              />
            </View>
          </View>

          <View style={{ marginTop: 10 }} />
          <FlatList
            ListFooterComponent={<View style={{ padding: 80 }}></View>}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
            data={merchantData}
            renderItem={({ item }) => (
              <ScrollView showsVerticalScrollIndicator={false}>
                <View
                  style={{
                    backgroundColor: "#F6EFE9",
                    //paddingHorizontal: 20,
                    paddingTop: 14,
                    paddingBottom: 20,
                    borderRadius: 10,
                    marginBottom: 20,
                  }}
                >
                  <View
                    style={[
                      styles.FlatImg,
                      {
                        borderBottomWidth: 1,
                        borderBottomColor: "#9C49001A",
                      },
                    ]}
                  >
                    <View
                      style={{
                        flexDirection: "row",
                        marginLeft: 20,
                        paddingBottom: 14,
                        //  alignItems: "center",
                      }}
                    >
                      <Image
                        source={item.profilePic}
                        style={{ width: 50, height: 46 }}
                        resizeMode="contain"
                      />
                      <View style={{ marginLeft: 20 }}>
                        <Text
                          style={{
                            color: AppColors.dualbrown,
                            fontSize: 12,
                            fontFamily: AppFonts.OverpassRegular,
                          }}
                        >
                          {t("common:translation.Merchant Name")}{" "}
                        </Text>
                        <Text
                          style={{
                            color: "#8F4300",
                            fontSize: 14,
                            fontFamily: AppFonts.OverpassSemiBold,
                            marginTop: 3,
                          }}
                        >
                          {item.name}
                        </Text>
                      </View>
                    </View>
                    <TouchableOpacity onPress={() => setDotModal(true)}>
                      <Image
                        source={AppImages.Threedots}
                        style={{
                          width: 20,
                          height: 20,
                          // alignItems: "center",
                          marginRight: 20,
                          marginTop: -10,
                        }}
                        resizeMode="contain"
                      />
                    </TouchableOpacity>
                  </View>
                  <View style={{ marginHorizontal: 20 }}>
                    <View
                      style={{
                        flexDirection: "row",
                        marginTop: 10,
                      }}
                    >
                      <Text
                        style={{
                          color: "#8F430080",
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                          width: "50%",
                        }}
                      >
                        Merchant ID
                      </Text>
                      <Text
                        style={{
                          color: "#8F430080",
                          fontSize: 12,
                          fontFamily: AppFonts.OverpassRegular,
                          width: "50%",
                        }}
                      >
                        Merchant Email
                      </Text>
                    </View>
                    <View
                      style={{
                        flexDirection: "row",
                        marginTop: 5,
                      }}
                    >
                      <Text
                        style={{
                          color: "#8F4300",
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                          // marginTop: 3,
                          width: "50%",
                        }}
                      >
                        {item.merchantID}
                      </Text>
                      <Text
                        style={{
                          color: "#8F4300",
                          fontSize: 14,
                          fontFamily: AppFonts.OverpassSemiBold,
                          // marginTop: 3,
                          width: "50%",
                        }}
                      >
                        {item.merchantEmail}
                      </Text>
                    </View>
                  </View>
                </View>
              </ScrollView>
            )}
          />
        </View>
      </View>
      <Modal
        animationType="slide"
        visible={DotModal}
        onRequestClose={() => {
          setDotModal(false);
        }}
        transparent={true}
      >
        <TouchableWithoutFeedback onPress={() => setDotModal(false)}>
          <View
            style={{
              backgroundColor: AppColors.ModalColor,
              flex: 1,
              opacity: 0.55,
            }}
          ></View>
        </TouchableWithoutFeedback>
        <View
          style={{
            width: "100%",
            backgroundColor: "white",

            borderTopRightRadius: 16,
            borderTopLeftRadius: 16,
            position: "absolute",
            bottom: 0,
            padding: 20,
          }}
        >
          <TouchableOpacity
            style={{ justifyContent: "center", alignItems: "center" }}
          >
            <Image
              source={AppImages.LineBar}
              style={{ width: "15%", height: 2 }}
            />
          </TouchableOpacity>

          <TouchableWithoutFeedback
            style={{
              marginTop: 20,
              flexDirection: "row",
            }}
            onPress={() => [
              setDotModal(false),

              navigation.navigate("#"),
              handleTextPress(1),
            ]}
          >
            <View
              style={{
                marginLeft: 10,
              }}
            >
              <Text
                style={[styles.text, activeIndex === 1 && styles.activeText]}
              >
                View
              </Text>
            </View>
          </TouchableWithoutFeedback>
          <TouchableWithoutFeedback
            style={{
              marginTop: 20,
              flexDirection: "row",
            }}
            onPress={() => [
              setDotModal(false),
              navigation.navigate("#"),
              handleTextPress(2),
            ]}
          >
            <View
              style={{
                marginLeft: 10,
              }}
            >
              <Text
                style={[styles.text, activeIndex === 2 && styles.activeText]}
              >
                Edit
              </Text>
            </View>
          </TouchableWithoutFeedback>

          <TouchableWithoutFeedback
            style={{
              marginTop: 20,
              flexDirection: "row",
            }}
            onPress={() => [handleDeleteConfirmation(), handleTextPress(3)]}
          >
            <View
              style={{
                marginLeft: 10,
              }}
            >
              <Text
                style={[styles.text, activeIndex === 3 && styles.activeText]}
              >
                Delete
              </Text>
            </View>
          </TouchableWithoutFeedback>
        </View>
      </Modal>
      <Modal
        animationType="slide"
        transparent={true}
        visible={Modalvisible1}
        onRequestClose={() => {
          setModalvisible1(!Modalvisible1);
        }}
      >
        <Pressable
          onPress={() => setModalvisible1(true)}
          style={{
            flex: 1,
            backgroundColor: "rgba(66, 31, 0, 0.5)",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              backgroundColor: AppColors.white,
              width: "90%",
              padding: 20,
              borderRadius: 15,
              margin: 20,
            }}
          >
            <View style={{}}>
              <TouchableOpacity
                onPress={() => navigation.navigate("Changelogo")}
              >
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown1,
                      fontFamily: AppFonts.OverpassRegular,
                      fontSize: 20,
                    }}
                  >
                    Delete
                  </Text>
                  <TouchableOpacity onPress={() => setModalvisible1(false)}>
                    <Image
                      source={AppImages.cross}
                      style={{ height: 13, width: 12 }}
                    />
                  </TouchableOpacity>
                </View>
              </TouchableOpacity>
              <View
                style={{
                  borderWidth: 0.2,
                  borderColor: AppColors.sandal,
                  marginTop: 20,
                  marginBottom: 20,
                }}
              ></View>

              <Text
                style={{
                  color: AppColors.brown,
                  fontFamily: AppFonts.OverpassRegular,
                  fontSize: 14,
                  width: "100%",
                }}
              >
                Are you sure you want to Delete ?
              </Text>
              <View
                style={{
                  borderWidth: 0.2,
                  borderColor: AppColors.sandal,
                  marginTop: 20,
                  marginBottom: 20,
                }}
              ></View>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <TouchableOpacity
                  onPress={() => setModalvisible1(false)}
                  style={{
                    width: "30%",
                    height: 44,
                    borderColor: AppColors.brown,
                    borderWidth: 1,
                    borderRadius: 15,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.brown,
                      fontFamily: AppFonts.OverpassSemiBold,
                      fontSize: 14,
                    }}
                  >
                    Cancel
                  </Text>
                </TouchableOpacity>
                <TouchableOpacity
                  onPress={() => "#"}
                  style={{
                    width: "30%",
                    height: 44,
                    backgroundColor: AppColors.brown,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 15,
                    marginLeft: 20,
                  }}
                >
                  <Text
                    style={{
                      color: AppColors.white,
                      fontFamily: AppFonts.OverpassSemiBold,
                      fontSize: 14,
                    }}
                  >
                    Delete
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Pressable>
      </Modal>
    </SafeAreaView>
  );
};

export default Merchant;
const styles = StyleSheet.create({
  MainView: { backgroundColor: AppColors.sandal, flex: 1 },
  SecMain: { backgroundColor: AppColors.white, marginHorizontal: 20 },
  TExtinputView: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",

    marginTop: 20,
    width: "100%",
    height: height * 0.07,
  },
  TExtinput: {
    fontSize: 12,
    alignItems: "center",
    fontFamily: AppFonts.OverpassMedium,
    width: "90%",
    borderRadius: 10,
    borderColor: AppColors.sandal,
    height: height * 0.07,
    borderWidth: 1,
  },
  ExImport: { flexDirection: "row", marginHorizontal: 10 },
  Flatmain: {
    marginTop: 20,
    backgroundColor: "#F6EFE9",
    borderRadius: 10,
  },
  FlatmainSec: {
    margin: 10,
    marginLeft: 20,
  },
  FlatImg: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  FlatTxt: { marginLeft: 20 },
  FlatTxtSec: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  FlatTxtT2: {
    fontSize: 14,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  LineBars: {
    width: "100%",
    right: 20,
    // position: 'absolute',
    borderTopColor: AppColors.brown,
    borderTopWidth: 0.7,
    opacity: 0.099,
    marginTop: 10,
  },
  CopyText: {
    fontSize: 14,
    marginTop: 12,
    fontWeight: "700",
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
  },
  CopyTextSec: {
    width: "50%",
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassRegular,
    color: AppColors.brown1,
    fontWeight: "700",
  },
  NonCopy: {
    width: width * 0.4,
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
    // fontWeight: '700',
  },
  Row: { flexDirection: "row", flex: 1, alignItems: "center" },

  Textt: {
    width: "50%",
    marginTop: 10,
    fontSize: 12,

    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },

  TextTwo: {
    fontSize: 12,
    marginTop: 10,
    fontFamily: AppFonts.OverpassMedium,
    color: AppColors.brown1,
  },
  text: {
    fontFamily: AppFonts.OverpassMedium,

    fontSize: 14,
    color: AppColors.dualbrown,
    marginTop: 10,
  },
  activeText: {
    fontFamily: AppFonts.OverpassMedium,
    marginTop: 10,
    fontSize: 14,
    color: AppColors.brown1,
  },
});
